import React from 'react';
import { useTenant } from 'src/state/redux/selector/tenant';
import ActiveUser from 'src/state/global/ActiveUser';
import QuickFiltersHome from './QuickFiltersHome';
import QuickFiltersProvider from './QuickFiltersProvider';
import QuickFiltersHomeUI2 from './QuickFiltersHomeUI2';

const QuickFiltersWrapper: React.FC<{ ui2?: boolean }> = ({ ui2 = false }) => {
  const tenantORM = useTenant(ActiveUser.user!.tenantId);
  const quickFilters = tenantORM?.tenant.config.quickFilters;
  if (!quickFilters) return null;
  return (
    <QuickFiltersProvider quickFilters={quickFilters}>
      {ui2 ? <QuickFiltersHomeUI2 /> : <QuickFiltersHome />}
    </QuickFiltersProvider>
  )
}

export default QuickFiltersWrapper;
